import React from 'react';
import AppStoreBadges from './AppStoreBadges';
import './AppDownloadBand.css';

export default function AppDownloadBand() {
  return (
    <div className="container tp-app-band-wrap">
      <section className="tp-app-band">
        <div className="tp-app-band__copy">
          <h2 className="headline-1 tp-app-band__title">Download the Faye app</h2>
          <p className="body-l tp-app-band__body">
            Your eSIM and lounge pass are activated and used inside the Faye app. To claim these benefits, make sure you have it downloaded before you travel.
          </p>
        </div>
        <AppStoreBadges qrSize={104} />
      </section>
    </div>
  );
}
